




































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { ProviderInstance } from 'vee-validate/dist/types/types'
import { InputSelectOption } from '@/helpers/options'

@Component
export default class InputSelect extends Vue {
    @Ref() validator!: ProviderInstance
    @Ref() optionsContainer!: HTMLDivElement
    @Prop({ type: String }) readonly vid!: string
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop({ type: Boolean, default: false }) readonly labelOutside!: boolean
    @Prop({ required: true }) readonly options!: InputSelectOption[]
    @Prop({ default: null }) readonly value!: string
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly clearOnSelect!: boolean
    @Prop({ type: Boolean, default: false }) readonly inline!: boolean
    @Prop({ type: Boolean, default: false }) readonly inlineAlignTop!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    @Prop({ type: Boolean, default: false }) readonly sm!: boolean
    @Prop({ type: Boolean, default: false }) readonly rounded!: boolean
    @Prop({ type: String, default: '' }) readonly placeholder!: string
    internalValue: string = null
    showOptions: boolean = false

    created() {
        this.internalValue = this.value
        window.addEventListener('click', this.onOutsideClick)
    }

    mounted() {
        this.calculateOptionsTop()
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('options')
    onOptionsChanged() {
        if (this.internalValue && !this.options.some(option => option.value === this.internalValue)) {
            this.internalValue = null
        }
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        await this.validator.validate(this.internalValue)
        this.$emit('input', this.internalValue)

        if (this.clearOnSelect) {
            this.clear()
        }
    }

    applyClass(option: {label: string, subtext: string, value: string }) {
        if (this.value === option.value) {
            return ['input-select__option--selected']
        }

        return []
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    selectOption(option: {label: string, subtext: string, value: string }): void {
        this.internalValue = option.value
        this.showOptions = false
    }

    get isClearable(): boolean {
        return this.clearable && this.internalValue !== null && this.internalValue !== '' && !this.disabled
    }

    clear(): void {
        this.internalValue = null
        this.showOptions = false
    }

    get selectedOption() {
        const selectedOption = this.options.find(value => value.value === this.internalValue)
        if (!selectedOption) {
            return null
        }

        return selectedOption
    }

    get selectedOptionIndex() {
        return this.options.findIndex(value => value.value === this.internalValue)
    }

    optionsTop: number = 0

    @Watch('selectedOptionIndex')
    calculateOptionsTop() {
        if (this.inline) {
            const selectedOption = this.optionsContainer.children[this.selectedOptionIndex]
            if (selectedOption && !this.inlineAlignTop) {
                // @ts-ignore
                this.optionsTop = -5 - selectedOption.offsetTop
            } else {
                this.optionsTop = -5
            }
        } else {
            this.optionsTop = -10
        }
    }

    get componentClass(): object {
        return {
            'input-select': true,
            'input-select--sm': this.sm,
            'input-select--disabled': this.disabled,
            'input-select--inline': this.inline,
            'input-select--white': this.white,
            'input-select--rounded': this.rounded,
        }
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
